import facebook from './handlers/facebook';
import kwai from './handlers/kwai';
import taboola from './handlers/taboola';
import gtm from './handlers/gtm';
import type { Handlers } from '@/types/Metrics';
import { Singleton } from '@/shared/@cactus/web/classes/singleton';

export class MetricsInstance extends Singleton {
  public static get instance(): MetricsInstance {
    return MetricsInstance.Instance<MetricsInstance>(MetricsInstance);
  }

  /**
   * Build an push an valid user event data.
   * @param eventTracker name of tracker
   * @returns void
   */
  push = <T extends keyof Handlers>(eventTracker: T) => {
    if (!import.meta.client) {
      return;
    }

    if (!eventTracker) {
      console.error('metrics: Should be informed an event tracker name');
    }

    try {
      return new Trackers<T>(eventTracker);
    } catch (err) {
      console.warn(`metrics: ${eventTracker}`);
      console.error(err);
    }
  };
}

class Trackers<T extends keyof Handlers> {
  private eventTracker: T;

  constructor(eventTracker: T) {
    this.eventTracker = eventTracker;
  }

  handle(...args: Handlers[T]): void {
    if (this.eventTracker === 'facebook') {
      return this.facebook(args as Handlers['facebook']);
    }

    if (this.eventTracker === 'kwai') {
      return this.kwai(args as Handlers['kwai']);
    }

    if (this.eventTracker === 'taboola') {
      return this.taboola(args as Handlers['taboola']);
    }

    if (this.eventTracker === 'gtm') {
      return this.gtm(args as Handlers['gtm']);
    }

    throw new Error('metrics: Invalid tracker');
  }

  private facebook = facebook;

  private kwai = kwai;

  private taboola = taboola;

  private gtm = gtm;
}
